/**
 * Runtime configuration sourced from environment variables.
 *
 * Policy URLs come only from the environment — no hardcoded default. When a var
 * is unset the value is an empty string, and the registration page renders that
 * policy label as non-clickable text (see PolicyLink in Register.tsx).
 */

export const CONSENT_POLICY_URL = import.meta.env.VITE_CONSENT_POLICY_URL ?? '';

export const PRIVACY_POLICY_URL = import.meta.env.VITE_PRIVACY_POLICY_URL ?? '';
